<div class="flex-column height-20">

</div>
<div class="flex-column center-content">
    <h1> What is Customer Journey </h1>
</div>
<div class="flex-column center-content half-width">


    <p>In a broader sense, a customer journey is a way of describing the process of shaping customers’ experiences
        at
        each stage of the interaction cycle, and in a larger scope, influencing their perception of the applications
        and
        features. It is a new way of exploring customer behavior.</p>

    <p>From a targeted angle, Customer Journey (CJ) is a Loan Star component that implements the “customer journey”
        paradigm in the single page application that interfaces the end user (borrower.)</p>

    <p>CJ is a custom, in-house built application that uses “configurable delta hooks” inserted into the Angular
        (Typescript) CRUD methods to collect data that is presented to the user or collected from the user
        (messages,
        actions, navigation, etc.) </p>
</div>


<div class="flex-row center-content">
    <h2>Let's get started</h2>
</div>

<div class="flex-row center-content half-width">
    <mat-form-field class="half-width">
        <input matInput placeholder="SIN or BorrowerId" autocomplete="off" [(ngModel)]="sinOrBorrowerId">
    </mat-form-field>
    <button mat-stroked-button color="primary" (click)="onSearchBorrowerClicked()">Search</button>
</div>
<div>
    <p>Use one of the following identifiers to test the application: <i>12345678</i> &nbsp;| <i>87654321</i></p>
</div>